import { useLocation } from "react-router-dom";
import AddPlaceForm from "../components/widgets/AddPlaceForm/AddPlaceForm";
import { useTranslatedTitle } from "../utils/utils";

const CurrentlyReading = () => {
  const location = useLocation();
  const state = location.state as {
    prefilledLocation?: { lat: number; lng: number; name: string };
  };

  useTranslatedTitle("title.currentlyReading");

  return <AddPlaceForm prefilledLocation={state?.prefilledLocation || null} />;
};

export default CurrentlyReading;
